import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  activeSlug?: string;
}

export default function CategoryTabs({ activeSlug }: CategoryTabsProps) {
  const location = useLocation();
  const currentSlug = activeSlug || location.pathname.split('/category/')[1] || '';

  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <div className="flex items-center gap-2 px-4 md:px-8 py-3 min-w-max">
        <Link
          to="/"
          className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
            !currentSlug
              ? 'bg-accent-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
          }`}
        >
          全部
        </Link>
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
              currentSlug === cat.slug
                ? 'bg-accent-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
            }`}
          >
            {cat.name}
          </Link>
        ))}
      </div>
    </div>
  );
}